module.exports = __webpack_public_path__ + "nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf?5abcad441ff4902097a3dad526934ab6";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf
// module id = 1308
// module chunks = 15